import { styled } from '@mui/material'
import Box from '@mui/material/Box'

export const RequestBox = styled(Box, {
    shouldForwardProp: (propName: string) => propName !== 'isMainPage',
})<{ isMainPage: boolean; isBackground: boolean }>(({ isMainPage, isBackground }) => ({
    background: isBackground ? '#F4F4F6' : '',
    position: 'relative',
    margin: isMainPage ? `32px auto 10px` : `0 0 14px`,
    padding: isMainPage ? '16px' : '12px 16px',
    borderRadius: '24px',
    border: '1px solid #DEDFE3',
    textAlign: 'left',
    boxShadow: !isMainPage ? '0px 4px 10px 0px #0000000A' : '',
}))
